import React, { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'

import CreatePaymentMethodModal from '@modals/CreatePaymentMethodModal'

import PageContent from './components/PageContent'

const callbacks = (component, setState) => {
  const componentCallbacks = {
    CreatePaymentMethodModal: {
      closeModal: () => setState({ showCreatePaymentMethodModal: false }),
      createPaymentMethod: payload => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreatePaymentMethodModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showCreatePaymentMethodModal,
  } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreatePaymentMethodModal: () => setState({ showCreatePaymentMethodModal: true }),
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreatePaymentMethodModal
          callbacks={callbacks('CreatePaymentMethodModal', setState)}
          showModal={showCreatePaymentMethodModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
